(function ($) {
    "use strict";
    var animationLoddin = [];
    function loadCFAnimation(loader, id, loop, autoplay) {
        animationLoddin[id] = bodymovin.loadAnimation({
            container: loader,
            renderer: "svg",
            loop: loop,
            autoplay: autoplay,
            rendererSettings: {
                progressiveLoad: true
            },
            path: loader.getAttribute('data-json-url'),
        });
        loader.classList.add("loaded");
    }
    
    var waitingLoader = document.getElementsByClassName("ajax-loader");
    for (var i = 0; i < waitingLoader.length; i++) {
        waitingLoader[i].index = i;
        if(!waitingLoader[i].classList.contains('loaded')){
            loadCFAnimation(waitingLoader[i], 'w' + i, true, true);
        }
    }
})(jQuery);